<template>
  <custom-field-input-base :field="field" v-bind="normalizedProps">
    <v-text-field
      :model-value="modelValue"
      :rules="rules"
      :readonly="normalizedProps.readOnly"
      :hide-details="normalizedProps.hideDetails"
      :variant="normalizedProps.outlined ? 'outlined' : 'filled'"
      :persistent-placeholder="normalizedProps.persistentPlaceholder"
      :placeholder="field.placeholder"
      density="comfortable"
      @update:model-value="handleInput" />
  </custom-field-input-base>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { CustomFieldProps } from '../types';
import CustomFieldInputBase from '../CustomFieldInputBase.vue';
import { useCustomFieldProps } from '@satellite/composables/useCustomFieldProps';
import { useCustomFieldValidation } from '@satellite/composables/useCustomFieldValidation';

/**
 * String field type - single line text input
 */
const props = defineProps<CustomFieldProps>();

const emit = defineEmits<{
  'update:model-value': [value: string];
  /** @deprecated Use update:model-value instead */
  // TODO: Remove this event after the migration is complete
  input: [value: string];
}>();

const { normalizedProps } = useCustomFieldProps(props);
const { rules } = useCustomFieldValidation(computed(() => props.field));

function handleInput(value: string) {
  emit('update:model-value', value);
  emit('input', value);
}
</script>
